import Vue from 'vue'
import Router from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { // 首页
      path: '/',
      name: 'home',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/home/index')), 'home')
    },
    { // 首页-活动预告详情
      path: '/events',
      name: 'events',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/home/events')), 'events')
    },
    { // 关于我们
      path: '/aboutUs',
      name: 'aboutUs',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/aboutUs/index')), 'aboutUs')
    },
    { // 联系我们
      path: '/contact',
      name: 'contact',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/contact/index')), 'contact')
    },
    { // 全球会展
      path: '/egpc',
      name: 'egpc',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/egpc/index')), 'egpc')
    },
    { // 当年会展
      path: '/inThoseYears',
      name: 'inThoseYears',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/inThoseYears/index')), 'inThoseYears')
    },
    { // 合作伙伴
      path: '/partnership',
      name: 'partnership',
      component: resolve => require.ensure([], ()=> resolve(require('@/pages/partnership/index')), 'partnership')
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // 如果存在保存的滚动位置，则使用它
    if (savedPosition) {
      return savedPosition;
    } else {
      // 否则，滚动到目标元素或顶部
      return { x: 0, y: 0 }; // 滚动到顶部
      // 或者返回 { selector: '#myElement' } 来滚动到特定的元素
    }
  }
})
export default router
